/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AtoNDefinitionAlarmSetupInner } from './AtoNDefinitionAlarmSetupInner';
import {
    AtoNDefinitionAlarmSetupInnerFromJSON,
    AtoNDefinitionAlarmSetupInnerFromJSONTyped,
    AtoNDefinitionAlarmSetupInnerToJSON,
} from './AtoNDefinitionAlarmSetupInner';
import type { AtoNDefinitionPosition } from './AtoNDefinitionPosition';
import {
    AtoNDefinitionPositionFromJSON,
    AtoNDefinitionPositionFromJSONTyped,
    AtoNDefinitionPositionToJSON,
} from './AtoNDefinitionPosition';
import type { AtoNDefinitionScheduleInner } from './AtoNDefinitionScheduleInner';
import {
    AtoNDefinitionScheduleInnerFromJSON,
    AtoNDefinitionScheduleInnerFromJSONTyped,
    AtoNDefinitionScheduleInnerToJSON,
} from './AtoNDefinitionScheduleInner';

/**
 * 
 * @export
 * @interface AtoN
 */
export interface AtoN {
    /**
     * Whether the AtoN is autonomous
     * @type {boolean}
     * @memberof AtoN
     */
    autonomous?: boolean;
    /**
     * id of a pss used for chaining
     * @type {string}
     * @memberof AtoN
     */
    chainedaton?: string;
    /**
     * id of a pss used for chaining
     * @type {string}
     * @memberof AtoN
     */
    chained?: string;
    /**
     * State of aton, only set for physical's
     * @type {number}
     * @memberof AtoN
     */
    state?: number;
    /**
     * Interval between broadcasts in seconds
     * @type {number}
     * @memberof AtoN
     */
    broadcastInterval?: number;
    /**
     * Description of the AtoN
     * @type {string}
     * @memberof AtoN
     */
    description?: string;
    /**
     * Whether the AtoN is enabled
     * @type {boolean}
     * @memberof AtoN
     */
    enabled?: boolean;
    /**
     * Seconds before a failure timeout is raised when AtoN is unresponsive
     * @type {number}
     * @memberof AtoN
     */
    failureTimeout?: number;
    /**
     * List of groups the AtoN is shared with
     * @type {Array<string>}
     * @memberof AtoN
     */
    groups?: Array<string>;
    /**
     * MMSI of AtoN
     * @type {number}
     * @memberof AtoN
     */
    mmsi?: number;
    /**
     * Name of AtoN
     * @type {string}
     * @memberof AtoN
     */
    name?: string;
    /**
     * Owner of AtoN
     * @type {string}
     * @memberof AtoN
     */
    owner?: string;
    /**
     * 
     * @type {AtoNDefinitionPosition}
     * @memberof AtoN
     */
    position?: AtoNDefinitionPosition;
    /**
     * List of PSS associated with the AtoN
     * @type {Array<string>}
     * @memberof AtoN
     */
    pss?: Array<string>;
    /**
     * Schedule for data collection of the AtoN
     * @type {Array<AtoNDefinitionScheduleInner>}
     * @memberof AtoN
     */
    schedule?: Array<AtoNDefinitionScheduleInner>;
    /**
     * Physical size in meters of dimension a of AtoN
     * @type {number}
     * @memberof AtoN
     */
    sizeA?: number;
    /**
     * Physical size in meters of dimension b of AtoN
     * @type {number}
     * @memberof AtoN
     */
    sizeB?: number;
    /**
     * Physical size in meters of dimension c of AtoN
     * @type {number}
     * @memberof AtoN
     */
    sizeC?: number;
    /**
     * Physical size in meters of dimension d of AtoN
     * @type {number}
     * @memberof AtoN
     */
    sizeD?: number;
    /**
     * Off position alarm. Can be note (0), warning (1) and alert (2)
     * @type {number}
     * @memberof AtoN
     */
    offPosAlarm?: number;
    /**
     * Type of AtoN
     * @type {number}
     * @memberof AtoN
     */
    type?: number;
    /**
     * Whether it is virtual (0) or synthetic (1)
     * @type {number}
     * @memberof AtoN
     */
    virtual?: AtoNVirtualEnum;
    /**
     * Alarm setup
     * @type {Array<AtoNDefinitionAlarmSetupInner>}
     * @memberof AtoN
     */
    alarmSetup?: Array<AtoNDefinitionAlarmSetupInner>;
    /**
     * When to give timeout warning in seconds
     * @type {number}
     * @memberof AtoN
     */
    warningTimeout?: number;
    /**
     * Unique identifier for the AtoN
     * @type {string}
     * @memberof AtoN
     */
    uuid?: string;
}


/**
 * @export
 */
export const AtoNVirtualEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type AtoNVirtualEnum = typeof AtoNVirtualEnum[keyof typeof AtoNVirtualEnum];


/**
 * Check if a given object implements the AtoN interface.
 */
export function instanceOfAtoN(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AtoNFromJSON(json: any): AtoN {
    return AtoNFromJSONTyped(json, false);
}

export function AtoNFromJSONTyped(json: any, ignoreDiscriminator: boolean): AtoN {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'autonomous': !exists(json, 'autonomous') ? undefined : json['autonomous'],
        'chainedaton': !exists(json, 'chainedaton') ? undefined : json['chainedaton'],
        'chained': !exists(json, 'chained') ? undefined : json['chained'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'broadcastInterval': !exists(json, 'broadcast_interval') ? undefined : json['broadcast_interval'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'failureTimeout': !exists(json, 'failure_timeout') ? undefined : json['failure_timeout'],
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'position': !exists(json, 'position') ? undefined : AtoNDefinitionPositionFromJSON(json['position']),
        'pss': !exists(json, 'pss') ? undefined : json['pss'],
        'schedule': !exists(json, 'schedule') ? undefined : ((json['schedule'] as Array<any>).map(AtoNDefinitionScheduleInnerFromJSON)),
        'sizeA': !exists(json, 'size_a') ? undefined : json['size_a'],
        'sizeB': !exists(json, 'size_b') ? undefined : json['size_b'],
        'sizeC': !exists(json, 'size_c') ? undefined : json['size_c'],
        'sizeD': !exists(json, 'size_d') ? undefined : json['size_d'],
        'offPosAlarm': !exists(json, 'off_pos_alarm') ? undefined : json['off_pos_alarm'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'virtual': !exists(json, 'virtual') ? undefined : json['virtual'],
        'alarmSetup': !exists(json, 'alarm_setup') ? undefined : ((json['alarm_setup'] as Array<any>).map(AtoNDefinitionAlarmSetupInnerFromJSON)),
        'warningTimeout': !exists(json, 'warning_timeout') ? undefined : json['warning_timeout'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
    };
}

export function AtoNToJSON(value?: AtoN | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'autonomous': value.autonomous,
        'chainedaton': value.chainedaton,
        'chained': value.chained,
        'state': value.state,
        'broadcast_interval': value.broadcastInterval,
        'description': value.description,
        'enabled': value.enabled,
        'failure_timeout': value.failureTimeout,
        'groups': value.groups,
        'mmsi': value.mmsi,
        'name': value.name,
        'owner': value.owner,
        'position': AtoNDefinitionPositionToJSON(value.position),
        'pss': value.pss,
        'schedule': value.schedule === undefined ? undefined : ((value.schedule as Array<any>).map(AtoNDefinitionScheduleInnerToJSON)),
        'size_a': value.sizeA,
        'size_b': value.sizeB,
        'size_c': value.sizeC,
        'size_d': value.sizeD,
        'off_pos_alarm': value.offPosAlarm,
        'type': value.type,
        'virtual': value.virtual,
        'alarm_setup': value.alarmSetup === undefined ? undefined : ((value.alarmSetup as Array<any>).map(AtoNDefinitionAlarmSetupInnerToJSON)),
        'warning_timeout': value.warningTimeout,
        'uuid': value.uuid,
    };
}

